// ignore-string-externalization

import { graphqlAssetToContentful } from '../Contentful';
import { createUTCDate } from '../../utils/dateUtils';
import type { BlogItem } from './blogQueries';
import { getEmptyCategoriesState } from './blogCategories';

const monthsShort = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

function formatShortDate(date: Date) {
  const day = `0${date.getDate()}`.slice(-2);
  const month = monthsShort[date.getMonth()];
  return `${month} ${day}, ${date.getFullYear()}`;
}

// Output shape (byId, slugToId, allSlugs) preserved from Redux store to avoid changes in consuming components
export function normalizeBlogItems(items: BlogItem[]) {
  const categories = getEmptyCategoriesState();
  const posts = {
    byId: {} as Record<string, any>,
    slugToId: {} as Record<string, string>,
    allSlugs: [] as string[],
  };

  for (const item of items) {
    if (!item) continue;
    const releaseDateParsed = createUTCDate(item.releaseDate as string);

    posts.byId[item.sys.id] = {
      id: item.sys.id,
      title: item.title,
      urlSlug: item.urlSlug,
      introduction: item.introduction,
      description: item.description,
      category: 'Other',
      body: item.article,
      featuredMediaFullsize: false,
      featuredMediaDisplayFirst: true,
      featuredVideo: null,
      featuredAsset: graphqlAssetToContentful(item.headerModule?.image),
      releaseDate: releaseDateParsed.toISOString(),
      releaseDateUTC: releaseDateParsed.toUTCString(),
      releaseDateFormatted: formatShortDate(releaseDateParsed),
    };
  }

  categories.allSlugs.forEach((slug: string) => {
    categories.bySlug[slug].items = [];
  });

  Object.values(posts.byId)
    .sort((a: any, b: any) => {
      if (a.releaseDate === b.releaseDate) return 0;
      return a.releaseDate > b.releaseDate ? -1 : 1;
    })
    .forEach((item: any) => {
      categories.bySlug.all.items.push(item.id);
      const categorySlug = categories.nameToSlug[item.category];
      if (categories.bySlug[categorySlug]) {
        categories.bySlug[categorySlug].items.push(item.id);
      }
      posts.slugToId[item.urlSlug] = item.id;
    });

  posts.allSlugs = categories.bySlug.all.items.map(
    (id: string) => posts.byId[id].urlSlug,
  );

  return { blogCategories: categories, blogPosts: posts };
}
